import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.10_@playwright+test@1.52.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"preload\":true,\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/app/node_modules/.pnpm/nuqs@2.4.3_next@15.4.10_@playwright+test@1.52.0_react-dom@19.1.0_react@19.1.0__react@19.1.0__react@19.1.0/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ApiUrlProvider"] */ "/app/src/providers/ApiUrl.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/src/providers/Session.tsx");
